import React from "react";
import StatusChip from "./StatusChip";

/**
 * UserStatusBadge
 *
 * Tiny wrapper over <StatusChip> so the operator console renders user
 * Active/Inactive consistently as a soft success/neutral badge instead
 * of red error text dominating every row.
 *
 *   <UserStatusBadge active={u.active} />
 *
 * Active → soft green ("fresh")
 * Inactive → soft gray ("neutral")
 */
export default function UserStatusBadge({ active, "data-testid": testId }) {
  if (active) {
    return (
      <StatusChip tone="fresh" data-testid={testId || "user-status-active"}>
        Active
      </StatusChip>
    );
  }
  return (
    <StatusChip tone="neutral" data-testid={testId || "user-status-inactive"}>
      Inactive
    </StatusChip>
  );
}
